export class FormBase {
  public id: string;
  public title: string;
  public introduction: string;
  public confirmation: string;
  public publicLinkInstructions: string;

  isAnyApplication(): boolean {
    return this.title === FormBase.getAnyApplicationTitle();
  }

  public static getAnyApplicationTitle(): string {
    return 'Any Lineup Form';
  }

  public static getMemberApplicationTitle(): string {
    return 'Form';
  }
}
